import { motion } from "framer-motion";

function ProgressContainer({ isLoading, duration = 60, children, ...props }) {
  if (isLoading) {
    return (
      <motion.div
        {...props}
        initial={{
          background: `linear-gradient(90deg,  var(--primary-cta) ${0}%, var(--grey-2) ${0}%)`,
        }}
        animate={{
          background: `linear-gradient(90deg, var(--primary-cta)  90%, var(--grey-2) 90%)`,
          transition: {
            duration,
            ease: "linear",
          },
        }}
      >
        {children}
      </motion.div>
    );
  }
  return <div {...props}>{children}</div>;
}

export default ProgressContainer;
